import api from '../api';
import { API_URL } from '../config';

export const createContractRenewalFeedback = async (data) => {
  const response = await api.post('/contract-renewal-feedback', data);
  return response.data;
};

export const getAllContractRenewalFeedbacks = async () => {
  const response = await api.get('/contract-renewal-feedback');
  return response.data;
};

export const getContractRenewalFeedbackById = async (id) => {
  const response = await api.get(`/contract-renewal-feedback/${id}`);
  return response.data;
};

export const updateContractRenewalFeedback = async (id, data) => {
  const response = await api.put(`/contract-renewal-feedback/${id}`, data);
  return response.data;
};

export const deleteContractRenewalFeedback = async (id) => {
  const response = await api.delete(`/contract-renewal-feedback/${id}`);
  return response.data;
};
